"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
/**
 * 注册制审核首页
 */
require("../../src/modules/slidetips");
var web_1 = __importDefault(require("../../config/web"));
var fieldtools_1 = __importDefault(require("../../src/modules/commonutil/fieldtools"));
var statusdata = {};
var loadtablestatus = { zcz: false, qy: false };
if (!fieldtools_1["default"].isEmpty(fieldtools_1["default"].getUrlParam("type"))) {
    $("#filter_type li").removeClass("at");
    $("#box_zcz").hide();
    $("#box_qy").show();
    $(".tipinfo").show();
    $(".searchinfo").hide();
    loadqytable();
}
else
    loadzcztable();
//事件配置
loadevent();
function loadevent() {
    $(".searchinfo .searchbtn").on('click', function () {
        var value = $(".searchinfo input").val();
        if (value) {
            searchname(value);
        }
    });
    $("#filter_type li").on('click', function () {
        $("#filter_type li").removeClass("at");
        $(this).addClass("at");
        if ($(this).data("value") == "zcz") {
            $("#box_zcz").show();
            $("#box_qy").hide();
            $(".searchinfo").show();
            $(".tipinfo").hide();
            loadzcztable();
        }
        else {
            $("#box_zcz").hide();
            $("#box_qy").show();
            $(".tipinfo").show();
            $(".searchinfo").hide();
            loadqytable();
        }
    });
}
function loadzcztable() {
    if (loadtablestatus.zcz)
        return;
    var opt = {
        dataurl: {
            hostname: 'datacenter',
            url: 'api/data/v1/get',
            params: {
                reportName: 'RPT_REGISTERED_INFO',
                columns: "ORG_CODE,ISSUER_NAME,CHECK_STATUS,CHECK_STATUS_CODE,REG_ADDRESS,CSRC_INDUSTRY,RECOMMEND_ORG,LAW_FIRM,ACCOUNT_FIRM,UPDATE_DATE,ACCEPT_DATE,TOLIST_MARKET,SECURITY_CODE",
                token: '894050c76af8597a853f5b408b759f5d',
                client: "WEB"
            }
        },
        sortname: 'UPDATE_DATE',
        filteroptions: [{
                name: 'filter',
                fieldname: 'mkt',
                filterselector: "#MARKET_type",
                filtersoptionselector: "li",
                selectedclass: "at",
                values: {
                    "cyb": '(TOLIST_MARKET="创业板")',
                    "kcb": '(TOLIST_MARKET="科创板")',
                    "bjs": '(TOLIST_MARKET="北交所")'
                }
            }, {
                name: 'filter',
                fieldname: 'status',
                filterselector: "#STATUS_type",
                filtersoptionselector: "li",
                selectedclass: "at",
                values: {
                    "ysl": '(CHECK_STATUS_CODE in ("0101","001"))',
                    "ywx": '(CHECK_STATUS_CODE in ("0201","002"))',
                    "tg": '(CHECK_STATUS_CODE in ("0301","0304","003","011","013"))',
                    "tjzc": '(CHECK_STATUS_CODE in ("0401","005"))',
                    "zcjg": '(CHECK_STATUS_CODE in ("0402","0403","0404","006","007","017","015"))',
                    "wtg": '(CHECK_STATUS_CODE in ("0302","0305","004","014"))',
                    "zz": '(CHECK_STATUS_CODE in ("0601","0602","010","012"))'
                }
            }],
        columns: {
            xiangguan: {
                formatter: function (value, item, i, field) {
                    var gburl = "//" + (window.ymcdx2guba || "guba.eastmoney.com") + "/list," + (item.SECURITY_CODE ? item.SECURITY_CODE : ("gs" + item.ORG_CODE)) + ".html";
                    var type = 'kcb';
                    if (item.TOLIST_MARKET == "创业板") {
                        type = 'cyb';
                    }
                    else if (item.TOLIST_MARKET == "北交所") {
                        type = 'bjs';
                    }
                    return "<a class=\"red\" target=\"_blank\" href=\"/zcz/" + type + "/" + item.SECURITY_CODE + ".html\">\u8BE6\u7EC6</a> <a href=\"" + gburl + "\" target=\"_blank\">\u80A1\u5427</a>";
                }
            },
            ISSUER_NAME: {
                formatter: function (value, item, i, field) {
                    var type = 'kcb';
                    if (item.TOLIST_MARKET == "创业板") {
                        type = 'cyb';
                    }
                    else if (item.TOLIST_MARKET == "北交所") {
                        type = 'bjs';
                    }
                    return "<a  href=\"/zcz/" + type + "/" + item.SECURITY_CODE + ".html\" target=\"_blank\">" + item.ISSUER_NAME + "</a>";
                }
            }
        },
        onPreLoad: function (that, dataajaxOptions) {
            var spans = $("#STATUS_type li span");
            var type = $("#MARKET_type li.at").text();
            if (type == '全部')
                type = '汇总';
            spans.eq(0).html("(" + (statusdata[type + "\u5168\u90E8"] || '0') + ")");
            spans.eq(1).html("(" + (statusdata[type + "\u5DF2\u7ECF\u53D7\u7406"] || '0') + ")");
            spans.eq(2).html("(" + (statusdata[type + "\u5DF2\u95EE\u8BE2"] || '0') + ")");
            spans.eq(3).html("(" + (statusdata[type + "\u901A\u8FC7"] || '0') + ")");
            spans.eq(4).html("(" + (statusdata[type + "\u63D0\u4EA4\u6CE8\u518C"] || '0') + ")");
            spans.eq(5).html("(" + (statusdata[type + "\u6CE8\u518C\u7ED3\u679C"] || '0') + ")");
            spans.eq(6).html("(" + (statusdata[type + "\u672A\u901A\u8FC7"] || '0') + ")");
            spans.eq(7).html("(" + (statusdata[type + "\u7EC8\u6B62"] || '0') + ")");
        },
        onChangefilter: function () {
            $(".searchinfo input").val("");
        }
    };
    loadstatus().then(function () {
        $("#dataview_zcz").emdataview(opt);
        loadtablestatus.zcz = true;
    });
}
function loadqytable() {
    if (loadtablestatus.qy)
        return;
    var opt = {
        dataurl: {
            hostname: 'datacenter',
            url: 'api/data/v1/get',
            params: {
                reportName: 'RPT_KCB_IPO',
                columns: 'KCB_LB',
                source: "WEB",
                client: "WEB"
            }
        },
        sortname: 'NOTICE_DATE,SECURITY_CODE',
        filteroptions: [{
                name: 'filter',
                fieldname: 'type',
                filterselector: "#filter_type",
                filtersoptionselector: "li.qy",
                selectedclass: "at",
                values: function (value) {
                    return "(ORG_TYPE_CODE=\"" + (value == 'db' ? '03' : '02') + "\")";
                }
            }],
        columns: {
            "ORG_NAME": {
                formatter: function (value, item, i, field) {
                    return "<a href=\"/zcz/kcb/" + item.SECURITY_CODE + ".html\">" + item.ORG_NAME + "</a>";
                }
            },
            "xg": {
                formatter: function (value, item, i, field) {
                    return "<a class=\"red\" href=\"/zcz/kcb/" + item.SECURITY_CODE + ".html\">\u8BE6\u7EC6</a>";
                }
            },
            "RELATED_STOCK": {
                formatter: function (value, item, i, field) {
                    if (!item.RELATED_STOCK)
                        return '-';
                    var RankCode = item.RELATED_STOCK.split(',');
                    var names = [];
                    RankCode.forEach(function (item) {
                        var arr = item.split('|');
                        if (arr.length > 1)
                            names.push("<a href=\"/stockdata/" + arr[0] + ".html#zygd\">" + fieldtools_1["default"].fmtsname(arr[1]) + "</a>");
                    });
                    return names.join('<br/>');
                }
            },
            "ACCUM_NETPROFIT_2Y": emfield.num,
            "BUSINESS_SCOPE": emfield.title_10,
            "OPERATE_INCOME_1Y": {
                formatter: function (value, item, i, field) {
                    if (fieldtools_1["default"].isEmpty(value))
                        return '-';
                    return fieldtools_1["default"].fieldfmt(value, { omit: true }) + "<br/>(" + item.YEAR_1Y + ")";
                }
            },
            "OPERATE_INCOME_2Y": {
                formatter: function (value, item, i, field) {
                    if (fieldtools_1["default"].isEmpty(value))
                        return '-';
                    return fieldtools_1["default"].fieldfmt(value, { omit: true }) + "<br/>(" + item.YEAR_2Y + ")";
                }
            },
            "OPERATE_INCOME_3Y": {
                formatter: function (value, item, i, field) {
                    if (fieldtools_1["default"].isEmpty(value))
                        return '-';
                    return fieldtools_1["default"].fieldfmt(value, { omit: true }) + "<br/>(" + item.YEAR_3Y + ")";
                }
            },
            "NETPROFIT_1Y": {
                formatter: function (value, item, i, field) {
                    if (fieldtools_1["default"].isEmpty(value))
                        return '-';
                    return fieldtools_1["default"].fieldfmt(value, { omit: true }) + "<br/>(" + item.YEAR_1Y + ")";
                }
            },
            "NETPROFIT_2Y": {
                formatter: function (value, item, i, field) {
                    if (fieldtools_1["default"].isEmpty(value))
                        return '-';
                    return fieldtools_1["default"].fieldfmt(value, { omit: true }) + "<br/>(" + item.YEAR_2Y + ")";
                }
            },
            "NETPROFIT_3Y": {
                formatter: function (value, item, i, field) {
                    if (fieldtools_1["default"].isEmpty(value))
                        return '-';
                    return fieldtools_1["default"].fieldfmt(value, { omit: true }) + "<br/>(" + item.YEAR_3Y + ")";
                }
            },
            "RESEARCH_1Y": {
                formatter: function (value, item, i, field) {
                    if (fieldtools_1["default"].isEmpty(value))
                        return '-';
                    return fieldtools_1["default"].fieldfmt(value, { omit: true }) + "<br/>(" + item.YEAR_1Y + ")";
                }
            },
            "RESEARCH_2Y": {
                formatter: function (value, item, i, field) {
                    if (fieldtools_1["default"].isEmpty(value))
                        return '-';
                    return fieldtools_1["default"].fieldfmt(value, { omit: true }) + "<br/>(" + item.YEAR_2Y + ")";
                }
            },
            "RESEARCH_3Y": {
                formatter: function (value, item, i, field) {
                    if (fieldtools_1["default"].isEmpty(value))
                        return '-';
                    return fieldtools_1["default"].fieldfmt(value, { omit: true }) + "<br/>(" + item.YEAR_3Y + ")";
                }
            }
        },
        onPreBody: function (data, that) {
            return;
            if (data && data.length) {
                var item = data[0];
                that.updateColumnTitle([
                    { field: "OPERATE_INCOME_1Y", title: item.YEAR_1Y },
                    { field: "NETPROFIT_1Y", title: item.YEAR_1Y },
                    { field: "RESEARCH_1Y", title: item.YEAR_1Y },
                    { field: "OPERATE_INCOME_2Y", title: item.YEAR_2Y },
                    { field: "NETPROFIT_2Y", title: item.YEAR_2Y },
                    { field: "RESEARCH_2Y", title: item.YEAR_2Y },
                    { field: "OPERATE_INCOME_3Y", title: item.YEAR_3Y },
                    { field: "NETPROFIT_3Y", title: item.YEAR_3Y },
                    { field: "RESEARCH_3Y", title: item.YEAR_3Y }
                ]);
            }
        }
    };
    $("#dataview_qy").emdataview(opt);
    loadtablestatus.qy = true;
}
function loadstatus() {
    return $.ajax({
        url: web_1["default"].getWebPath('datacenter') + 'api/data/v1/get',
        type: 'GET',
        dataType: 'jsonp',
        data: {
            reportName: 'RPT_REGISTERED_INFO_STATISTICS',
            columns: 'CHECK_STATUS,CHECK_STATUS_CODE,CHECK_STATUS_NUM,TOLIST_MARKET',
            token: '894050c76af8597a853f5b408b759f5d',
            client: "WEB"
        },
    }).then(function (json) {
        var datas = json.result && json.result.data;
        if (datas) {
            datas.forEach(function (item) {
                statusdata["" + item.TOLIST_MARKET + item.CHECK_STATUS] = item.CHECK_STATUS_NUM;
            });
        }
    });
}
function searchname(value) {
    $.ajax({
        url: web_1["default"].getWebPath('datacenter') + 'api/data/v1/get',
        type: 'GET',
        dataType: 'jsonp',
        data: {
            reportName: 'RPT_REGISTERED_INFO',
            columns: "ORG_CODE,ISSUER_NAME,CHECK_STATUS,CHECK_STATUS_CODE,REG_ADDRESS,CSRC_INDUSTRY,RECOMMEND_ORG,LAW_FIRM,ACCOUNT_FIRM,UPDATE_DATE,ACCEPT_DATE,TOLIST_MARKET,SECURITY_CODE",
            token: '894050c76af8597a853f5b408b759f5d',
            filter: "(ISSUER_NAME like \"%" + value + "%\")",
            client: "WEB"
        },
    }).then(function (json) {
        $("#dataview_zcz").emdataview("load", json);
        $("#MARKET_type li").removeClass("at").eq(0).addClass("at");
        $("#STATUS_type li").removeClass("at").eq(0).addClass("at");
        $("#dataview_zcz").emdataview()["options"].filteroptions[0].value = "";
        $("#dataview_zcz").emdataview()["options"].filteroptions[1].value = "";
    });
}
